import { tracker } from '@kueski-dev/web-observability';
import { getInteractionChannel } from '@kueski-analytics/getInteractionChannel';
import { AmplitudeProductType } from 'Src/models/Amplitude/ProductTypes';
import { AMPLITUDE_KUESKI } from 'Src/consts/observabilityTargets';
import { TrackerMediator } from '@kueski-analytics/utils/TrackerMediator';
import { EVENT_FEATURE_FLAGS } from '@kueski-analytics/utils/EventFeatureFlags';
import { AMPLITUDE_PROVIDER } from '../providers';
import { AnalyticsManager } from '../AnalyticsManager';

/* eslint-disable camelcase */
export interface EmailVerification {
  application_id?: string | null;
  is_embedded_amz?: boolean;
  kueski_user_id?: string | null;
  merchant_id?: string;
  merchant_name?: string;
  page_name: string;
  product_type?: AmplitudeProductType;
  purchase_amount?: number;
  recurrent?: boolean;
}
/* eslint-enable camelcase */

export function sendEmailVerificationEvent(
  // eslint-disable-next-line camelcase
  { page_name, ...event }: EmailVerification,
) {
  const oldEvent = () => {
    const analytics = new AnalyticsManager();
    analytics.addProvider(AMPLITUDE_PROVIDER);
    // DEPRECATED: remove analytics.sendEvent
    return analytics.sendEvent('screen_viewed', {
      ...event,
      app_channel: getInteractionChannel(),
      page_name,
      page_viewed_at: `${new Date().getTime()}`,
    });
  };

  const newEvent = () => (
    tracker.track('screen_viewed', {
      attributes: { page_name },
      customAttributes: {
        ...event,
        app_channel: getInteractionChannel(),
        page_viewed_at: `${new Date().getTime()}`,
      },
      target: AMPLITUDE_KUESKI,
    })
  );

  const mediator = new TrackerMediator(EVENT_FEATURE_FLAGS.funnel);
  mediator
    .addOldTracker(oldEvent)
    .addNewTracker(newEvent)
    .track();
}
